import { useId } from "react";
import { useTranslation } from "react-i18next";
import type { QuestionProps } from "../types";
import { choiceInput, choiceRow } from "./choiceStyles";
import { QuestionShell } from "./QuestionShell";

export function YesNo(props: QuestionProps) {
  const { t } = useTranslation();
  const id = useId();
  const { question, value, onChange, disabled } = props;
  return (
    <QuestionShell props={props} inputId={id} asGroup>
      {({ labelId, helpId }) => (
        <div role="radiogroup" aria-labelledby={labelId} aria-describedby={helpId} className="flex flex-wrap gap-3">
          {[true, false].map((v) => (
            <label key={String(v)} className={`${choiceRow} min-w-28`}>
              <input
                type="radio"
                className={choiceInput}
                name={`${id}-${question.id}`}
                checked={value === v}
                disabled={disabled}
                onChange={() => onChange(v)}
              />
              <span>{v ? t("questionnaire.yes") : t("questionnaire.no")}</span>
            </label>
          ))}
        </div>
      )}
    </QuestionShell>
  );
}
